import { dynamicTime, shortTimestamp } from 'shared/helpers/timeHelper';
import { isDirectMessageChannel } from 'alibsoftInternalChat/channelDisplay';

export function stripMessageMarkup(text) {
  if (!text) return '';
  let clean = text.replace(/\[@([^\]]*)\]\(mention:\/\/[^)]*\)/g, '@$1');
  clean = clean.replace(/\[([^\]]*)\]\([^)]*\)/g, '$1');
  return clean.replace(/<[^>]+>/g, '');
}

export function unixFromTimestamp(value) {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') {
    return value > 1e12 ? Math.floor(value / 1000) : value;
  }
  const numeric = Number(value);
  if (Number.isFinite(numeric) && String(value).trim() !== '') {
    return numeric > 1e12 ? Math.floor(numeric / 1000) : numeric;
  }
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : Math.floor(parsed / 1000);
}

export function relativeActivityLabel(value) {
  const unix = unixFromTimestamp(value);
  if (!unix) return '';
  return shortTimestamp(dynamicTime(unix));
}

export function lastMessagePreview(channel, t) {
  const message = channel?.last_message;
  if (!message) return '';

  if (message.content_type === 'poll') {
    return t('INTERNAL_CHAT.HOME.POLL');
  }

  const content = stripMessageMarkup(message.content)
    .replace(/\s+/g, ' ')
    .trim();
  if (!content) {
    return t('INTERNAL_CHAT.HOME.ATTACHMENT');
  }

  if (!isDirectMessageChannel(channel) && message.sender_name) {
    return `${message.sender_name}: ${content}`;
  }

  return content;
}
